// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__aqi6T"};